import type * as React from 'react'

import { cn } from '../lib/cn'
import {
  LOCKUP_ACCENT,
  LOCKUP_NAME,
  LOCKUP_STRIPES,
  LOCKUP_VIEW_BOX,
} from './volee-lockup-vector.mjs'

// The full lockup, from the vector the boot screen in index.html draws too. On an ink island: the
// name is the island's white, the V and the accent lime.

export interface VoleeLockupProps {
  /** The image's accessible name, already translated: the product's name. Empty is decorative. */
  label: string
  /** The stripes of the V come in one after the other, once. Off, the lockup stands still. */
  opening?: boolean
  /** Positioning only: the height is the lockup's own. On the outermost element. */
  className?: string
}

export function VoleeLockup({ label, opening = false, className }: VoleeLockupProps) {
  const stripeClass = cn(
    'origin-center [transform-box:fill-box]',
    opening && 'animate-entry-stripe',
  )
  return (
    <svg
      viewBox={LOCKUP_VIEW_BOX}
      role={label === '' ? undefined : 'img'}
      aria-label={label === '' ? undefined : label}
      aria-hidden={label === '' ? true : undefined}
      className={cn('h-(--size-brand-lockup) w-auto overflow-visible', className)}
    >
      <g className="fill-foreground">
        {LOCKUP_NAME.map(({ d, transform }) => (
          <path key={d + (transform ?? '')} transform={transform} d={d} />
        ))}
      </g>
      <g className="fill-volee-lime">
        {LOCKUP_ACCENT.map((d) => (
          <path key={d} d={d} />
        ))}
        {LOCKUP_STRIPES.map(([order, d]) => (
          <path
            key={d}
            d={d}
            style={{ '--r': order } as React.CSSProperties}
            className={stripeClass}
          />
        ))}
      </g>
    </svg>
  )
}
